module.exports = __webpack_public_path__ + "img/post-thumbnail-placeholder.9b2258ac.svg";